module.exports = __webpack_public_path__ + "img/puberty-decal-07.689b0340.png";